// import React, { useEffect, useState } from "react";
// import styles from "./Watchlist.module.css";
// import dashboardLogo from '../../assets/image/logo/thickWalletFullWhiteLogo.png'
// import { IoChevronDownOutline } from "react-icons/io5";
// import { FaPlus } from "react-icons/fa6";
// import Select from "react-select";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTrash, faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   selectUserWatchlist,
//   selectAllStocksForWatchlist,
// } from "./WatchlistSlice";
// import { getUserWatchlist, getAvailableStocks, updateUserWatchlist, deleteFromUserWatchlist, getAvailableIndices } from "./WatchlistSlice";
// import EditModal from "../../components/modal/EditModal";
// import { MdEdit } from "react-icons/md";

// export const Watchlist = () => {
//   const dispatch = useDispatch();
//   const [isOpenIndex, setIsOpenIndex] = useState(-1)
//   const user_watchlist_stocks = useSelector(selectUserWatchlist);
//   const all_watchlist_stocks = useSelector(selectAllStocksForWatchlist);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [inputValue, setInputValue] = useState('');
//   const [filteredOptions, setFilteredOptions] = useState(all_watchlist_stocks);
//   const [isModalOpen, setModalOpen] = useState(false);

//   useEffect(() => {
//     dispatch(getUserWatchlist());
//     dispatch(getAvailableStocks());
//     dispatch(getAvailableIndices());
//   }, [dispatch]);

//   const handleChange = (selectedOption) => {
//     console.log("change")
//     setSelectedOption(selectedOption);
//   };

//   const addStockToWatchlist = (stock, event) => {
//     const li = event.target.closest('li');
//     const id = li.getAttribute('id');
//     const obj = {
//       stock: stock,
//       id: id
//     }
//     dispatch(updateUserWatchlist(obj));
//   }

//   const deleteStockFromWatchlist = (stock, event) => {
//     const li = event.target.closest('ul');
//     const id = li.getAttribute('w-id');
//     const obj = {
//       stock,
//       id
//     }
//     dispatch(deleteFromUserWatchlist(obj));
//   }


//   const handleInputChange = (input) => {
//     console.log(input, all_watchlist_stocks)
//   setInputValue(input);
//   const filtered = all_watchlist_stocks.filter(option =>

//     //stockName
//     //stockSymbol
//     option.stockSymbol.toLowerCase().includes(input.toLowerCase())
//   );
//   console.log(filtered);

//   setFilteredOptions(filtered);
//   return input;
//   };

//   const openModal = () => {
//     setModalOpen(true);
//   };

//   // Function to close the modal
//   const closeModal = () => {
//     setModalOpen(false);
//   };

//   const customOption = ({ data, innerProps, selectProps }) => {

//     const handleOptionClick = (e) => {
//       e.preventDefault();
//       e.stopPropagation();
//     };

//     return (
//       <div
//         {...innerProps}
//         onClick={handleOptionClick}
//         className={styles.option}
//       >
//         <button>{data.stockSymbol}</button>
//         <button
//           type="button"
//           onClick={(e) => {
//             addStockToWatchlist(data, e)
//             e.preventDefault();
//             e.stopPropagation();
//           }}
//         >
//           {/* + ADD */}
//           <FaPlus />
//         </button>
//       </div>
//     );
//   };

//   const renderIndividualWatchList = (item, index) => {
//     return (
//       <>
//         <div className={styles.list_title} onClick={() => { if (isOpenIndex === index) { setIsOpenIndex(-1); } else { setIsOpenIndex(index) } }}>
//           <div>{item.watchlistName}</div>
//           <div className={styles.dropdown_action}>
//             <button onClick={openModal}><MdEdit /></button>
//             <button >
//               {/* <FontAwesomeIcon icon={faAngleDoubleDown} /> */}
//               <IoChevronDownOutline />
//             </button>
//           </div>
//         </div>
//         <EditModal
//           isOpen={isModalOpen}
//           onClose={closeModal}
//         >
//           <div className={styles.edit_input_wrapper}>
//             <label>Name</label>
//             <input />
//           </div>
//         </EditModal>

//         {isOpenIndex === index ? (
//           <>
//             <div className={styles.search}>
//               <Select
//                 value={selectedOption}
//                 onChange={handleChange}
//                 options={filteredOptions}
//                 isSearchable={true}
//                 placeholder="Search..."
//                 onInputChange={handleInputChange}
//                 components={{ Option: customOption }}
//                 onMenuOpen={() => setSelectedOption(null)} // Clear selected option when the menu is opened
//                 // onMenuClose={() => { }} 

//               />
//             </div>
//             <div className={styles.added_stocks}>
//               <ul w-id={item.watchlistId}>
//                 {item.stocks.map((item, index) => {
//                   return (
//                     <li key={index}>
//                       <span>
//                         {item.stockSymbol}
//                       </span>
//                       <button onClick={(event) => deleteStockFromWatchlist(item.stockId, event)}>
//                         {" "}
//                         <FontAwesomeIcon icon={faTrash} />
//                         {/* DELETE */}
//                       </button>

//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>
//           </>
//         ) : (
//           ""
//         )}
//       </>
//     );
//   };

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.feature_head}>
//         <img src={dashboardLogo} alt="" />
//       </div>

//       <div className={styles.sidebar_accordion_container}>
//         <ul className={styles.list_style}>
//           {user_watchlist_stocks.map((item, index) => {
//             return <li key={index} id={item.watchlistId}>{renderIndividualWatchList(item, index)}</li>;
//           })}
//         </ul>
//       </div>
//     </div>
//   );
// };



import React, { useEffect, useState, useRef } from "react";
import styles from "./Watchlist.module.css";
import dashboardLogo from '../../assets/image/logo/thickWalletFullWhiteLogo.png';
import { IoChevronDownOutline } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import {
  selectUserWatchlist,
  selectAllStocksForWatchlist,
  getUserWatchlist,
  getAvailableStocks,
  getAvailableIndices,
  updateUserWatchlist,
  deleteFromUserWatchlist
} from "./WatchlistSlice";
import EditModal from "../../components/modal/EditModal";
import { MdEdit } from "react-icons/md";
import axios from "axios";

export const Watchlist = () => {
  const dispatch = useDispatch();
  const [isOpenIndex, setIsOpenIndex] = useState(-1);
  const user_watchlist_stocks = useSelector(selectUserWatchlist);
  const all_watchlist_stocks = useSelector(selectAllStocksForWatchlist);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [watchlistName, setWatchlistName] = useState('');
  const [watchlistId, setWatchlistId] = useState(null);

  const [isExpanded, setIsExpanded] = useState(false);

  const [selectedWatchlistIndex, setSelectedWatchlistIndex] = useState(null);

  const accordionRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        accordionRef.current &&
        !accordionRef.current.contains(event.target)
      ) {
        setSelectedWatchlistIndex(null);
        setIsOpenIndex(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch initial data
  useEffect(() => {
    dispatch(getUserWatchlist());
    dispatch(getAvailableStocks());
    dispatch(getAvailableIndices());
  }, [dispatch]);

  // Map available stocks to react-select format
  useEffect(() => {
    if (all_watchlist_stocks?.length > 0) {
      const mapped = all_watchlist_stocks.map(stock => ({
        label: `${stock.stockSymbol} - ${stock.stockName}`,
        value: stock.stockUId,
        data: stock,
      }));
      setFilteredOptions(mapped);
    }
  }, [all_watchlist_stocks]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  // const handleInputChange = (input) => {
  //   setInputValue(input);
  //   const mapped = all_watchlist_stocks.map(stock => ({
  //     label: `${stock.stockSymbol} - ${stock.stockName}`,
  //     value: stock.stockUId,
  //     data: stock,
  //   }));
  //   const filtered = mapped.filter(option =>
  //     option.label.toLowerCase().includes(input.toLowerCase())
  //   );
  //   setFilteredOptions(filtered);
  //   return input;
  // };
  const handleInputChange = (input) => {
    setInputValue(input);

    if (input.length >= 2) {
      setShowOptions(true);
      const mapped = all_watchlist_stocks.map(stock => ({
        label: `${stock.stockSymbol} - ${stock.stockName}`,
        value: stock.stockUId,
        data: stock,
      }));
      const filtered = mapped.filter(option =>
        option.label.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setShowOptions(false);
      setFilteredOptions([]);
    }

    return input;
  };


  const addStockToWatchlist = (stock, event) => {
    const li = event.target.closest('li');
    const id = li.getAttribute('id');
    const obj = {
      stock: { stockId: stock.stockUId },
      id: id
    };
    dispatch(updateUserWatchlist(obj));
  };

  const deleteStockFromWatchlist = (stock, event) => {
    const li = event.target.closest('ul');
    const id = li.getAttribute('w-id');
    const obj = {
      stock,
      id
    };
    dispatch(deleteFromUserWatchlist(obj));
  };

  const openModal = (id, name) => {
    setWatchlistId(id)
    setWatchlistName(name)
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleEditWatchlistName = async () => {
    try {
      console.log(watchlistId);


      const body = {
        newWatchlistName: watchlistName
      }

      const result = axios.patch(`/api/watchlists/${watchlistId}`, body)

      setModalOpen(false)
      window.location.reload();

    } catch (error) {

    }
  }

  const customOption = ({ data, innerRef, innerProps }) => {
    const stock = data.data;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={styles.option}
      >
        <button>{stock.stockSymbol}</button>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            addStockToWatchlist(stock, e);
          }}
        >
          <FaPlus />
        </button>
      </div>
    );
  };

  const renderIndividualWatchList = (item, index) => {
    // console.log(item);

    return (
      <>
        <div className={`${styles.list_title}`}
          onClick={() => {
            setIsOpenIndex(isOpenIndex === index ? -1 : index);
          }}>
          <div>{item.watchlistName}</div>
          <div className={styles.dropdown_action}>
            <button><IoChevronDownOutline /></button>
            <button onClick={() => openModal(item.watchlistUId, item.watchlistName)}><MdEdit /></button>
          </div>
        </div>

        <EditModal isOpen={isModalOpen} onClose={closeModal}>
          <div className={styles.edit_input_wrapper}>
            <label>Name</label>
            <input value={watchlistName} onChange={(e) => setWatchlistName(e.target.value)} />
            <button onClick={() => handleEditWatchlistName()}>Submit</button>
          </div>
        </EditModal>

        {isOpenIndex === index && (
          <>
            <div className={styles.search}>
              {/* <Select
                value={selectedOption}
                onChange={handleChange}
                options={filteredOptions}
                isSearchable={true}
                placeholder="Search..."
                onInputChange={handleInputChange}
                components={{ Option: customOption }}
                onMenuOpen={() => setSelectedOption(null)}
              /> */}

              <Select
                value={selectedOption}
                onChange={handleChange}
                options={showOptions ? filteredOptions : []}
                isSearchable={true}
                placeholder="Search..."
                onInputChange={handleInputChange}
                components={{ Option: customOption }}
                onMenuOpen={() => setSelectedOption(null)}
              />

            </div>

            <div className={styles.added_stocks}>
              <ul w-id={item.watchlistUId}>
                {item.stocks.map((stockItem, i) => (
                  <li key={i}>
                    <span>{stockItem.stockSymbol}</span>
                    <button onClick={(event) => deleteStockFromWatchlist(stockItem.stockUId, event)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <div className={styles.wrapper}>
      {/* <div className={styles.feature_head}>
        <img src={dashboardLogo} alt="Logo" />
      </div> */}

      <div className={styles.watchlist_section}>
        <div className={styles.section_name}>
          <span>Watchlist</span>
        </div>
        <div className={styles.watchlist_icon_section}>
          {user_watchlist_stocks.map((item, index) => (
            <div
              key={index}
              className={styles.icon_container}
              onClick={() => {
                setSelectedWatchlistIndex(index)
                setIsOpenIndex(index)
              }}
            >
              <h4>{`W${index + 1}`}</h4>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.sidebar_accordion_container} ref={accordionRef}>
        <ul className={styles.list_style}>
          {user_watchlist_stocks
            .filter((_, index) => index === selectedWatchlistIndex)
            .map((item, index) => (
              <li key={item.watchlistUId} id={item.watchlistUId}>
                {renderIndividualWatchList(item, selectedWatchlistIndex)}
              </li>
            ))}
        </ul>

      </div>

      <button className={styles.expandBtn}
        onClick={() => {
          if (selectedWatchlistIndex === null) {
            setSelectedWatchlistIndex(0);
            setIsOpenIndex(0);
          } else {
            setSelectedWatchlistIndex(null);
            setIsOpenIndex(-1);
          }
        }}
      >{selectedWatchlistIndex === null ? (<FiChevronsLeft />) : (<FiChevronsRight />)}</button>
    </div>
  );
};
